import React, { Component } from 'react';
import { StaggeredMotion, spring } from 'react-motion';
import styled from 'styled-components';

class Mouse extends Component {
  state = {
    mouse: { x: 0, y: 0, opacity: 0 },
  };

  componentDidMount() {
    window.addEventListener('mousemove', this.onMouseMove);
    window.addEventListener('touchmove', this.onTouchMove);
    window.addEventListener('touchend', this.onMouseOut);
  }
  componentWillUnmount() {
    window.removeEventListener('mousemove', this.onMouseMove);
    window.removeEventListener('touchmove', this.onTouchMove);
    window.removeEventListener('touchend', this.onMouseOut);
  }
  onMouseMove = (e) => {
    if (
      e.clientX < 10 ||
      e.clientX > window.innerWidth - 10 ||
      e.clientY < 60 ||
      e.clientY > window.innerHeight - 10
    ) {
      this.onMouseOut();
    } else {
      this.setState({ mouse: { x: e.clientX, y: e.clientY, opacity: 1 } });
    }
  };
  onTouchMove = (e) => {
    e.preventDefault();
    this.setState({ mouse: { x: e.touches[0].clientX, y: e.touches[0].clientY, opacity: 1 } });
  };
  onMouseOut = () => {
    this.setState({ mouse: { x: 0, y: 0, opacity: 0 } });
  };
  render() {
    const { className } = this.props;
    const { x, y, opacity } = this.state.mouse;

    return (
      <div className={className}>
        <StaggeredMouse x={x} y={y} opacity={opacity} render={this.props.render} />
      </div>
    );
  }
}
const StaggeredMouse = ({
  x, y, opacity, render,
}) => (
  <StaggeredMotion
    defaultStyles={[{ x, y }, { x, y }, { x, y }]}
    styles={styles =>
      styles.map((_, i) =>
        (i === 0
          ? { x: spring(x), y: spring(y) }
          : { x: spring(styles[i - 1].x), y: spring(styles[i - 1].y) }))
    }
  >
    {styles => (
      <div className="mouse" style={{ opacity }}>
        {styles.map((style, i) => (
          <div key={i} style={{ transform: `translate(${style.x}px,${style.y}px)` }}>
            {render()}
          </div>
        ))}
      </div>
    )}
  </StaggeredMotion>
);

export default styled(Mouse)`
  position: fixed;
  left: 0;
  top: 0;
  width: 0;
  height: 0;
  .mouse {
    transition: opacity 1s;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Mouse/index.js